import permissions from "../constants/permissions";
import AdminModuleLayout from "@/views/Pages/AdminModule/AdminModuleLayout.vue";
import AdminModuleMenu from "@/views/Pages/AdminModule/AdminModuleMenu.vue";

//import middleware
import authorized from "@/middleware/authorized";
import authenticated from "@/middleware/authenticated";

//import pages
const AdminPage = () => import("@/views/Pages/AdminModule/AdminPage.vue");

const ListRolePage = () =>
  import("@/views/Pages/AdminModule/RoleManagement/ListRolePage.vue");

const ListUserPage = () =>
  import("@/views/Pages/AdminModule/UserManagement/ListUserPage.vue");

const ListOrganizationPage = () =>
  import(
    "@/views/Pages/AdminModule/OrganizationManagement/ListOrganizationPage.vue"
  );

const TemplatesPage = () =>
  import(
    "@/views/Pages/AdminModule/TemplatesManagement/TemplateModulesPage.vue"
  );

const ListResellerPage = () =>
  import("@/views/Pages/AdminModule/ResellerManagement/ListResellerPage.vue");

const ListLocationPage = () =>
  import("@/views/Pages/AdminModule/LocationManagement/ListLocationPage.vue");

const ListImportPage = () =>
  import("@/views/Pages/AdminModule/ImportModule/ListImportPage.vue");

const ListThirdPartyServicePage = () =>
  import(
    "@/views/Pages/AdminModule/ThirdPartyServiceModule/ListThirdPartyServicePage.vue"
  );

const ListTaxPage = () =>
  import("@/views/Pages/AdminModule/TaxManagement/ListTaxPage.vue");

const ListTaxGroupPage = () =>
  import("@/views/Pages/AdminModule/TaxGroupManagement/ListTaxGroupPage.vue");
const ListTemplateMailPage = () =>
  import("@/views/Pages/AdminModule/TemplateMailManagement/ListTemplateMailPage.vue");

const ListMailV2TemplatesPage = () =>
  import("@/views/Pages/AdminModule/MailV2/ListMailTemplatesPage.vue");
const MailV2SettingsPage = () =>
  import("@/views/Pages/AdminModule/MailV2/MailSettingsPage.vue");
const MailV2LogsPage = () =>
  import("@/views/Pages/AdminModule/MailV2/MailLogsPage.vue");
const MailV2LayoutPage = () =>
  import("@/views/Pages/AdminModule/MailV2/MailLayoutPage.vue");

/* const AddImportPage = () =>
  import("@/views/Pages/AdminModule/ImportModule/AddImport.vue");
const EditImportPage = () =>
  import("@/views/Pages/AdminModule/ImportModule/EditImportPage.vue");
const ViewImportPage = () =>
  import("@/views/Pages/AdminModule/ImportModule/ViewImportPage.vue"); */

let userManagementPages = {
  path: "users",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List Users",
      components: { default: ListUserPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_USERS,
        hasLevel2: true,
      },
    },
  ],
};

let roleManagementPages = {
  path: "roles",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List Roles",
      components: { default: ListRolePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_ROLES,
        hasLevel2: true,
      },
    },
  ],
};

let resellerManagementPages = {
  path: "resellers",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List Resellers",
      components: { default: ListResellerPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_RESELLERS,
        hasLevel2: true,
      },
    },
  ],
};

let organizationManagementPages = {
  path: "organizations",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List Organizations",
      components: { default: ListOrganizationPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_ORGANIZATIONS,
        hasLevel2: true,
      },
    },
  ],
};


let templateMailsManagementPages = {
  path: "template-mails",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List TemplateMails",
      components: { default: ListTemplateMailPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_TEMPLATES_MAILS,
        hasLevel2: true,
      },
    },
  ],
};

let mailV2ManagementPages = {
  path: "mail",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "templates",
      name: "Mail V2 Templates",
      components: { default: ListMailV2TemplatesPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_TEMPLATES_MAILS,
        hasLevel2: true,
      },
    },
    {
      path: "settings",
      name: "Mail V2 Settings",
      components: { default: MailV2SettingsPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_TEMPLATES_MAILS,
        hasLevel2: true,
      },
    },
    {
      path: "logs",
      name: "Mail V2 Logs",
      components: { default: MailV2LogsPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_TEMPLATES_MAILS,
        hasLevel2: true,
      },
    },
    {
      path: "layouts",
      name: "Mail V2 Layouts",
      components: { default: MailV2LayoutPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_TEMPLATES_MAILS,
        hasLevel2: true,
      },
    },
  ],
};

let templateManagementPages = {
  path: "templates",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "Templates Management",
      components: { default: TemplatesPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_ORGANIZATION_TEMPLATES,
        hasLevel2: true,
      },
    },
  ],
};

let locationsManagementPages = {
  path: "locations",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List Locations",
      components: { default: ListLocationPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_LOCATIONS,
        hasLevel2: true,
      },
    },
  ],
};

let importManagementPages = {
  path: "imports",
  component: AdminModuleLayout,
  children: [
    {
      path: "",
      name: "List Imports",
      components: { default: ListImportPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_IMPORTS,
      },
    },
    /* {
      path: "add",
      name: "Add Imports",
      components: { default: AddImportPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_CREATE_IMPORTS,
      },
    },
    {
      path: "edit/:id",
      name: "Edit Imports",
      components: { default: EditImportPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_EDIT_IMPORTS,
      },
    },
    {
      path: "view/:id",
      name: "View Imports",
      components: { default: ViewImportPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_IMPORTS,
      },
    }, */
  ],
};

let taxManagementPages = {
  path: "taxes",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List Taxes",
      components: { default: ListTaxPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_TAXES,
        hasLevel2: true,
      },
    },
  ],
};

let taxGroupManagementPages = {
  path: "tax-groups",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List TaxGroups",
      components: { default: ListTaxGroupPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_TAXES,
        hasLevel2: true,
      },
    },
  ],
};

let thirdPartyServicesManagementPages = {
  path: "third-party-services",
  components: {
    default: AdminModuleLayout,
    SidebarSecondLevelMenu: AdminModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List Third Party Services",
      components: { default: ListThirdPartyServicePage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_THIRD_PARTY_SERVICES,
        hasLevel2: true,
      },
    },
  ],
};

const adminModuleRoutes = [
  {
    path: "",
    components: {
      default: AdminModuleLayout,
      SidebarSecondLevelMenu: AdminModuleMenu,
    },
    children: [
      {
        path: "",
        name: "Admin Page",
        components: { default: AdminPage },
        meta: {
          middleware: authenticated,
          hasLevel2: true,
        },
      },
    ],
  },
  userManagementPages,
  roleManagementPages,
  organizationManagementPages,
  locationsManagementPages,
  resellerManagementPages,
  importManagementPages,
  templateManagementPages,
  templateMailsManagementPages,
  mailV2ManagementPages,
  thirdPartyServicesManagementPages,
  taxManagementPages,
  taxGroupManagementPages,
];

export default adminModuleRoutes;
